import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api";

export default function VerificationFacture() {

    const { numero } = useParams();

    const [loading, setLoading] = useState(true);
    const [facture, setFacture] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {

        const load = async () => {

            try {

                const res = await api.get(
                    `/factures/public/${numero}`
                );

                setFacture(res.data);

            } catch (err) {

                console.error(err);

                setError("Impossible de vérifier cette facture.");

            } finally {

                setLoading(false);

            }

        };

        load();

    }, [numero]);

    const formatMontant = (m) =>
        Number(m).toLocaleString("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + " USD";

    const formatDate = (d) =>
        new Date(d).toLocaleDateString("fr-FR");

    const statut = (s) => {

        switch (s) {

            case "payee":
                return "Facture soldée";

            case "partiel":
                return "Paiement partiel";

            default:
                return "En attente de paiement";

        }

    };

    if (loading) {

        return (

            <div className="min-h-screen flex items-center justify-center">

                Chargement...

            </div>

        );

    }

    if (error) {

        return (

            <div className="min-h-screen flex items-center justify-center text-red-600">

                {error}

            </div>

        );

    }

    if (!facture?.authentique) {

        return (

            <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">

                <div className="bg-white rounded-xl shadow-lg p-8 max-w-lg w-full text-center">

                    <div className="text-6xl mb-4">
                        ❌
                    </div>

                    <h1 className="text-2xl font-bold text-red-600">

                        Facture introuvable

                    </h1>

                    <p className="mt-4 text-gray-600">

                        Authentique : <b>Non</b>

                    </p>

                    <p className="mt-3 text-gray-500">

                        Cette facture n'existe pas dans la base de données d'Immeuble Alta.

                    </p>

                </div>

            </div>

        );

    }

    return (

        <div className="min-h-screen bg-gray-100 py-10 px-4">

            <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">

                <div className="bg-blue-700 text-white p-6 text-center">

                    <h1 className="text-3xl font-bold">

                        IMMEUBLE ALTA

                    </h1>

                    <p className="mt-2">

                        Vérification facture

                    </p>

                </div>

                <div className="p-8">

                    <div className="text-center mb-8">

                        <div className="text-6xl mb-3">
                            ✅
                        </div>

                        <h2 className="text-2xl font-bold text-green-700">

                            FACTURE AUTHENTIQUE

                        </h2>

                        <p className="mt-2">

                            Authentique : <b>Oui</b>

                        </p>

                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 gap-x-8">

                        <Info
                            label="N° de facture"
                            value={facture.numero}
                        />

                        <Info
                            label="Date de facturation"
                            value={formatDate(facture.date_facturation)}
                        />

                        <Info
                            label="Client"
                            value={facture.client}
                        />

                        <Info
                            label="Logement"
                            value={facture.logement}
                        />

                        <Info
                            label="Occupation"
                            value={facture.occupation}
                        />

                        <Info
                            label="Statut"
                            value={statut(facture.statut)}
                        />

                        <Info
                            label="Montant"
                            value={formatMontant(facture.montant)}
                        />

                        <Info
                            label="Montant payé"
                            value={formatMontant(facture.montant_paye)}
                        />

                        <Info
                            label="Reste à payer"
                            value={formatMontant(facture.reste)}
                        />

                        <Info
                            label="Vérifiée le"
                            value={
                                new Date().toLocaleString("fr-FR")
                            }
                        />

                    </div>

                    <div className="border-t mt-8 pt-5 text-center text-gray-500 text-sm">

                        © {new Date().getFullYear()} Immeuble Alta

                    </div>

                </div>

            </div>

        </div>

    );

}

function Info({ label, value }) {

    return (

        <div>

            <div className="text-sm text-gray-500">

                {label}

            </div>

            <div className="font-semibold text-gray-800">

                {value}

            </div>

        </div>

    );

}